import React from 'react';
import IdentitiesContainer from '../../containers/IdentitiesContainer';

const IdentitiesPage = () => {
  return <IdentitiesContainer />;
};

export default IdentitiesPage;
